import type { SearchFilters } from "@certa/queries/types/globalSearch.types";

export const checkIfAnyFilterIsApplied = (filters: SearchFilters): boolean => {
  return (
    filters.statusIds.length > 0 ||
    filters.startDate !== undefined ||
    filters.endDate !== undefined ||
    filters.objectStatusIds.length > 0
  );
};
